import React from 'react'
import { Routes, Route } from "react-router-dom";

import { FinanzaScreen } from '../componentes/view/finanzas/FinanzaScreen'; 

import ListaOM from '../componentes/view/comercial/om/listOm'; 
import Abono from '../componentes/view/finanzas/abonos/abonos'; 
import Abonoaut from '../componentes/view/finanzas/abonos/autorizar';
import TranporteAbono from '../componentes/view/finanzas/abonos/transporteabono';

export const FinanzaRoutes = () => {

  return (
    <Routes>            
      <Route path="/" element={ <FinanzaScreen /> } />
      <Route path="abono" element={ <Abono /> } /> 
      <Route path="abono-autorizacion" element={ <Abonoaut /> } /> 
      <Route path="TransporteAbonos" element={ <TranporteAbono /> } /> 
    </Routes>
  )
}
